
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';
import MarqueRequis from '../../Components/Form/MarqueRequis.jsx';

const Etape2QuiformeSuccess = ({ formData, setFormData, onPrevious, onNext }) => {

  function checkAllRight() {
    var pb = 0;
    
    if (formData.Email === '') {
      alert("Veuillez remplir tous les champs obligatoires.");  
      pb = 1;
    }
    else if (formData.OrgTelPortable === '' && formData.OrgTelFixe === '') {
      alert("Veuillez renseigner au moins un numéro de téléphone.");  
      pb = 1;
    }

    else if (formData.Email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email)) {
      alert("Veuillez entrer une adresse email valide.");
      pb = 1;
    }
    
    if(pb == 0) onNext();
  }

  // Pour test, on renseigne les champs obligatoires
  function renseigneToutPourTest() {    
    setFormData({      ...formData,
      EstCfa: true,
      Email: "test2@free.fr",
      OrgTelPortable: "0612345678",
      OrgTelFixe: "0498765432",  
      SiteWeb: "https://www.test.com"
    });
  }

  return (
    <div>
      {global.config.modeDebugAppDisplayInfosSupp == 1 && <div className='debug'>Etape2QuiformeSuccess</div>}
      <h3 className="pb-2">Informations sur votre Siret {formData.Siret} (source QuiForme) :</h3>
        <p>
            <strong>Raison sociale :</strong> {formData.RaisonSociale}<br />
            <strong>Sigle :</strong> {formData.Sigle}<br />
            {formData.RaisonSociale != formData.Denomination &&
              <><strong>Dénomination :</strong> {formData.Denomination}<br /></>}

            <strong>Enseigne :</strong> {formData.Enseigne}<br />
            <strong>Votre numéro UAI :</strong> {formData.Uai}<br />
            <br />

            <strong>Votre numéro de déclaration d'activité :</strong> {formData.NumDe}
            {formData.DateDerniereDeclaration != "" && 
              <> (Date de la dernière déclaration de votre activité : {formData.DateDerniereDeclaration})</>}
            <br />

            <strong>Adresse :</strong><br />
            {formData.Adresse1}<br />
            {formData.Codepostal}&nbsp;
            {formData.Commune}
            {formData.EstEnPaca == 1 ? " (département PACA)" : <span style={{ color: "red"}}> (département hors PACA : pour que la demande de création de compte soit acceptée, vous allez ensuite devoir préciser un lieu de formation en PACA)</span>}<br />
            <br />

            <strong>Code APE :</strong> {formData.Code_ape}<br />
            <strong>Catégorie juridique :</strong> {formData.Libelle_cat_juridique}<br />
            <strong>Date de création de votre établissement :</strong> {formData.Date_creation}<br />
            <br />

            <strong>Habilitation Qualiopi formation continue :</strong> {formData.QualiopiActionFormation == true ? "oui": "non"}<br />
            <strong>Habilitation Qualiopi bilan de competence :</strong> {formData.QualiopiBilanCompetence == true ? "oui": "non"}<br />
            <strong>Habilitation Qualiopi vae :</strong> {formData.QualiopiVae == true ? "oui": "non"}<br />
            <strong>Habilitation Qualiopi apprentissage :</strong> {formData.QualiopiApprentissage == true ? "oui": "non"}<br />
        </p>

      <textarea
        placeholder="S'il y avait une erreur, ou si des informations sont inexactes, veuillez nous en faire part ici"
        value={formData.Message}
        onChange={(e) => setFormData({ ...formData, Message: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "600px", height: "50px", marginRight: 10, display: "inline"}}
      />

      <p style={{paddingTop: "20px", fontWeight: "bold", fontSize: "1.3rem"}}>Merci de renseigner les informations complémentaires suivantes :</p>

      <ButtonDeBase typeSubmit={true} onClick={renseigneToutPourTest} lib="test : tout renseigner" className2="myside2" className=""/><br />
      
      <div style={{ paddingLeft: "10px", paddingTop: "10px"}}>
          <input 
            type="checkbox" 
            checked={!!formData.EstCfa}
            onChange={(e) => setFormData({ ...formData, EstCfa: e.target.checked })} //!!! bien noter ici le .checked !
            //className="form-check-input" 
            id="EstCfa" />
          <label htmlFor="EstCfa" style={{ paddingLeft: "10px", fontSize: "1.3rem"}}> Cet établissement est un CFA</label>
      </div>

      <p style={{paddingTop: "20px", fontWeight: "bold", fontSize: "1.3rem"}}>Coordonnées de votre organisme :</p>

      <input
        type="email"
        placeholder="Email"
        value={formData.Email}
        onChange={(e) => setFormData({ ...formData, Email: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "300px", margin: 10, display: "inline"}}
      /><MarqueRequis />
      <br />
      <input
        type="text"
        placeholder="Téléphone portable"
        value={formData.OrgTelPortable}
        onChange={(e) => setFormData({ ...formData, OrgTelPortable: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "200px", margin: 10, display: "inline"}}
      />
      <input
        type="text"
        placeholder="Téléphone fixe"
        value={formData.OrgTelFixe}
        onChange={(e) => setFormData({ ...formData, OrgTelFixe: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "200px", margin: 10, display: "inline"}}
      />
      <br />
      <input
        type="text"
        placeholder="Site web"
        value={formData.SiteWeb}
        onChange={(e) => setFormData({ ...formData, SiteWeb: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "500px", margin: 10, display: "inline"}}
      />
      <br />

      {/* quelle utilité ????
      <input
        type="text"
        placeholder="Nom du Réferent"
        value={formData.NomReferent}
        onChange={(e) => setFormData({ ...formData, NomReferent: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "500px", margin: 10, display: "inline"}}
      />
      <br />
      <input
        type="text"
        placeholder="Pénom du Réferent"
        value={formData.PrenomReferent}
        onChange={(e) => setFormData({ ...formData, PrenomReferent: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "500px", margin: 10, display: "inline"}}
      />
      <br />
      */}
      
      <div><span className="text-obligatoire">Les champs signalés d'un astérisque rouge * sont obligatoires.</span></div>
      <div className="partie-bouton-droite">
        <ButtonDeBase typeSubmit={false} onClick={onPrevious} lib="Étape précédente" className2="myside2" className="" />
        &nbsp;&nbsp;&nbsp;                
        <ButtonDeBase typeSubmit={true} onClick={checkAllRight} lib="Étape suivante" />
      </div>
    </div>
  );
};

export default Etape2QuiformeSuccess;
